export default __webpack_public_path__ + "static/media/BhAvatarTransparent.5a4a0cdc.png";